module.exports = __webpack_public_path__ + "media/images/lb/953-3cb2f3c739fa65eb73bd4930c11d01d8.svg";